// import isNil from 'lodash/isNil'
// import populate from 'coact/populate'

export default next => async (ctx) => {
  const { method } = ctx
  if (method === 'GET') return next(ctx)
  const { values } = ctx

  const key = values.key
  const storeName = values.storeName

  // generateKey
  values.name = [key, storeName].join('-')

  return next(ctx)
}



// WEBPACK FOOTER //
// ./src/views/middlewares/fillStoreKey.js